/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { IconProps } from './iconInterfaces';

export const NotificationBellIcon = ({ width=18, height=22, backgroundFillColor='#AEAEB2' }: IconProps) => {
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M9.00054 22C10.1005 22 10.9905 21.11 10.9905 20.01H7.01054C7.01054 21.11 7.90054 22 9.00054 22ZM17.2905 17.29L16.0005 16V10C16.0005 6.65 13.6405 3.85 10.5005 3.17V2C10.5005 1.17 9.83054 0.5 9.00054 0.5C8.17054 0.5 7.50054 1.17 7.50054 2V3.17C4.36054 3.85 2.00054 6.65 2.00054 10V16L0.71054 17.29C0.0805397 17.92 0.52054 19 1.41054 19H16.5805C17.4805 19 17.9205 17.92 17.2905 17.29ZM10.0005 15H8.00054V13H10.0005V15ZM10.0005 10C10.0005 10.55 9.55054 11 9.00054 11C8.45054 11 8.00054 10.55 8.00054 10V8C8.00054 7.45 8.45054 7 9.00054 7C9.55054 7 10.0005 7.45 10.0005 8V10Z' fill={backgroundFillColor}/>
        </svg>
    );
};

/**
 * 
 * Notification Bell Icon when there are no active hurricanes. 
 */
export const NotificationBellIconInActive = ({ width=18, height=22, backgroundFillColor='#AEAEB2' }: IconProps) => {
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M8 20C9.1 20 10 19.1 10 18H6C6 19.1 6.9 20 8 20ZM14 14V9C14 5.93 12.37 3.36 9.5 2.68V2C9.5 1.17 8.83 0.5 8 0.5C7.17 0.5 6.5 1.17 6.5 2V2.68C3.64 3.36 2 5.92 2 9V14L0 16V17H16V16L14 14ZM12 15H4V9C4 6.52 5.51 4.5 8 4.5C10.49 4.5 12 6.52 12 9V15Z' fill={backgroundFillColor}/>
        </svg>
    );
};